export const types = {
  // Auth Types
  login: '[Auth] Login',
  logout: '[Auth] Logout',
  // UI Types
  uiSetError: '[UI] Set Error',
  uiRemoveError: '[UI] Remove Error',
  // UI Loading
  uiStartLoading: '[UI] Start loading',
  uiFinishLoading: '[UI] Finish loading',
  // Notes Types
  notesAddNew: '[Notes] New note',
  notesActive: '[Notes] Set active note',
  notesLoad: '[Notes] Load notes',
  notesUpdated: '[Notes] Update note',
  notesFileUrl: '[Notes] Update image url',
  notesDelete: '[Notes] Delete note',
  notesLogoutCleaning: '[Notes] Logout Cleaning'
}